
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import CountryFlag from "@/components/country/CountryFlag";

interface VerificationCountryCardProps {
  countryCode: string;
  residencyStatus?: string;
}

const VerificationCountryCard = ({ countryCode, residencyStatus }: VerificationCountryCardProps) => {
  return (
    <Card className="bg-slate-50 border-slate-200">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Verification for</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center gap-2">
          <CountryFlag countryCode={countryCode} className="h-5 w-6" />
          <span className="font-medium">
            {countryCode}
            {residencyStatus && (
              <span className="ml-1 text-muted-foreground font-normal">
                ({residencyStatus})
              </span>
            )}
          </span>
        </div>
      </CardContent>
    </Card>
  );
};

export default VerificationCountryCard;
